import React from 'react';
import { Link } from 'react-router-dom';
import links from '../../../config/links';

const HighSchoolVerifiedRulesLink = (props) => {
    const link = links.highSchoolVerifiedRules;
    return (
        <Link to={link} target={props.target}>{props.children}</Link>
    );
};

export default HighSchoolVerifiedRulesLink;
